import { AUTH_BASE_URL } from "../../../envs"
import { HttpClient } from "../http-client"
import { TokenManager } from "../token-manager"
import { AuthClient } from "./auth-client"
import { CentsStripeClient } from "./cents-stripe-client"
import { CharitiesClient } from "./charities-client"
import { ContractsClient } from "./contracts-client"
import { FieldsClient } from "./fields-client"
import { LogsClient } from "./logs-client"

export class CentsClient {
  private readonly tokenManager: TokenManager = new TokenManager(AUTH_BASE_URL)
  private readonly httpClient: HttpClient = new HttpClient(this.tokenManager)
  public readonly auth: AuthClient
  public readonly fields: FieldsClient
  public readonly contracts: ContractsClient
  public readonly charities: CharitiesClient
  public readonly stripe: CentsStripeClient
  public readonly logs: LogsClient

  public constructor() {
    this.auth = new AuthClient(this.httpClient, this.tokenManager)
    this.fields = new FieldsClient(this.httpClient)
    this.contracts = new ContractsClient(this.httpClient)
    this.charities = new CharitiesClient(this.httpClient)
    this.stripe = new CentsStripeClient(this.httpClient)
    this.logs = new LogsClient(this.httpClient)
  }

  async initialize() {
    await this.tokenManager.refreshToken();
  }
}

export const centsClient = new CentsClient()
